const KIDS_CATEGORY_CODES = ['ENF', 'KID', 'KIDS', 'ENFA', 'ENFT'];
const KIDS_CATEGORY_KEYWORDS = ['enfant', 'enfants', 'kid', 'kids'];

export function isKidsCategory(categoryCode = '', categoryLabel = '') {
  const normalizedCode = (categoryCode || '').toUpperCase();
  if (normalizedCode && KIDS_CATEGORY_CODES.some((code) => normalizedCode.includes(code))) {
    return true;
  }

  const normalizedLabel = (categoryLabel || '').toLowerCase();
  if (normalizedLabel && KIDS_CATEGORY_KEYWORDS.some((keyword) => normalizedLabel.includes(keyword))) {
    return true;
  }

  return false;
}

export function createKidsServiceCodeSet(services = [], categories = []) {
  if (!Array.isArray(services) || services.length === 0) {
    return new Set();
  }

  const categoryLabelByCode = Array.isArray(categories)
    ? categories.reduce((acc, category) => {
        if (category?.categoryCode) {
          acc[category.categoryCode] = category.label || '';
        }
        return acc;
      }, {})
    : {};

  return new Set(
    services
      .filter((service) =>
        isKidsCategory(
          service?.categoryCode,
          service?.categoryLabel || categoryLabelByCode?.[service?.categoryCode] || '',
        ),
      )
      .map((service) => service.code)
      .filter(Boolean),
  );
}

export function hasKidsServicesFromCodes(serviceCodes = [], kidsServiceCodeSet = new Set()) {
  if (!Array.isArray(serviceCodes) || serviceCodes.length === 0 || kidsServiceCodeSet.size === 0) {
    return false;
  }
  return serviceCodes.some((code) => kidsServiceCodeSet.has(code));
}

export function hasKidsServicesFromCategoryMap(serviceCodes = [], serviceCategoryMap = {}) {
  if (!Array.isArray(serviceCodes) || serviceCodes.length === 0) {
    return false;
  }
  return serviceCodes.some((code) => isKidsCategory(serviceCategoryMap?.[code] || ''));
}

// Fonctions pour détecter les services "homme"
const MEN_CATEGORY_CODES = ['HOM', 'MEN', 'HOMME', 'MALE', 'MASC'];
const MEN_CATEGORY_KEYWORDS = ['homme', 'hommes', 'men', 'male', 'masculin'];

export function isMenCategory(categoryCode = '', categoryLabel = '') {
  const normalizedCode = (categoryCode || '').toUpperCase();
  if (normalizedCode && MEN_CATEGORY_CODES.some((code) => normalizedCode.includes(code))) {
    return true;
  }

  const normalizedLabel = (categoryLabel || '').toLowerCase();
  if (normalizedLabel && MEN_CATEGORY_KEYWORDS.some((keyword) => normalizedLabel.includes(keyword))) {
    return true;
  }

  return false;
}

export function hasMenServicesFromCategoryMap(serviceCodes = [], serviceCategoryMap = {}) {
  if (!Array.isArray(serviceCodes) || serviceCodes.length === 0) {
    return false;
  }
  return serviceCodes.some((code) => isMenCategory(serviceCategoryMap?.[code] || ''));
}


